export default __webpack_public_path__ + "static/media/steel.b3ea5060.jpeg";